import { initialState, CommodityState } from "./state";
import { Actions } from './actions';
import {
    COMMODITY_LIST, COMMODITY_BY_ID, ADD_COMMODITY_RESP, UPDATE_COMMODITY_RESP, DELETE_COMMODITY_RESP,
    COMMODITIES_LINKBY_CONTRACT_ID_RESP, COST_TRACKER_CONTRACTS_BY_COMMODITY_ID_RESPONSE, COMMODITY_BY_FIELD_LIST
} from "./actionTypes";
import { SortListAscending } from "app/utils/sort.util";

export function CommodityReducer(state = initialState, action: Actions): CommodityState {
    switch (action.type) {
        case COMMODITY_LIST:
            return Object.assign({}, state, {
                commodityList: SortListAscending(action.payload, "name")
            });
        case COMMODITY_BY_FIELD_LIST:
            return Object.assign({}, state, {
                commodityByFieldList: SortListAscending(action.payload, "name")
            });
        case COMMODITY_BY_ID:
            return Object.assign({}, state, {
                commodityById: action.payload
            });
        case ADD_COMMODITY_RESP:
            return Object.assign({}, state, {
                addCommodityResp: action.payload
            });
        case UPDATE_COMMODITY_RESP:
            return Object.assign({}, state, {
                updateCommodityResp: action.payload
            });
        case DELETE_COMMODITY_RESP:
            return Object.assign({}, state, {
                deleteCommodityResp: action.payload
            });
        case COMMODITIES_LINKBY_CONTRACT_ID_RESP:
            return Object.assign({}, state, {
                commodityLinkedToContractId: action.payload
            });
        case COST_TRACKER_CONTRACTS_BY_COMMODITY_ID_RESPONSE:
            return Object.assign({}, state, {
                costTrackerContractsByCommodityId: action.payload
            })
        default:
            return state;
    }
}
